import { checkDate } from "common/helpers/Date";
import { DateStringNumber, Nullable } from "common/records";
import { Record } from "immutable";

export const calendarFromJSON = (json: Partial<ICalendarData>): CalendarRecord => {
  const record: ICalendarRecord = { ...(json as any) };

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new CalendarRecord(record);
};

export interface ICalendarData {
  id: number;
  user_id: number;
  calendar_id: string;
  sync_dir: string;
  is_deleted: boolean;
  is_primary: boolean;
  is_readonly: boolean;
  metadata: any;
  name: string;
  profile_name: string;
  provider: string;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface ICalendarRecord {
  id: number;
  user_id: number;
  calendar_id: string;
  sync_dir: string;
  is_deleted: boolean;
  is_primary: boolean;
  is_readonly: boolean;
  metadata: any;
  name: string;
  profile_name: string;
  provider: string;

  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;
}

export const defaultCalendarProps = {
  id: 0,
  user_id: 0,
  calendar_id: "",
  sync_dir: "",
  is_deleted: false,
  is_primary: false,
  is_readonly: false,
  metadata: {},
  name: "",
  profile_name: "",
  provider: "",

  created_at: null,
  updated_at: null,
};

export class CalendarRecord extends Record<ICalendarRecord>(defaultCalendarProps) implements ICalendarRecord {}
